import React from "react";
import cs from "classnames";
import { ToolTip } from "../ToolTip";
import './FormGroup.scss';

type TFormGroup = {
  children?: JSX.Element | JSX.Element[];
  title?: string;
  titleUnit?: string;
  className?: string;
  tooltip?: string;
  size?: "small" | "regular";
};

export const FormGroup = ({
  children,
  tooltip,
  title,
  titleUnit,
  className,
  size = "regular",
}: TFormGroup) => {
  return (
    <div
      className={cs("c-hex-form-group-container", {
        "c-hex-form-group-container--small": size === "small",
      })}
    >
      <div className="c-hex-form-group-title-container">
        {title && (
          <p className="c-hex-form-group-title">
            {title}{" "}
            {titleUnit ? (
              <span className="c-hex-group-title-unit">({titleUnit})</span>
            ) : null}
          </p>
        )}
        {tooltip && <ToolTip text={tooltip} />}
      </div>
      {children}
    </div>
  );
};
